// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1eRDO","right":"Footer_right__1nbf3","buttons":"Footer_buttons__2f0pf"};